import axios from 'axios';
import { cacheMyUserId, getMyUserId } from '@/utils/auth';
import store from '@/store';

const endpoint = process.env.VUE_APP_AWS_MYPAGE_API_ENDPOINT;

const getAnonymousUserId = async () => {
  const response = await axios.get(`${endpoint}/anonymous-users/new`);
  const data = response.data;
  if (data.result !== 'success') {
    throw new Error(data.error);
  }
  return data.data.myKiUserId;
};

const confirmAnonymousId = async (id) => {
  const response = await axios.put(`${endpoint}/anonymous-users/${id}`);
  const data = response.data;
  if (data.result !== 'success') {
    throw new Error(data.error);
  }
  return data;
};

const getMe = async () => {
  // const token = await getApiTokenSilently();

  // we cache this id in localstorage to avoid unnecessary calls, and fall back to api when needed (cleared on logout)
  const cachedId = getMyUserId();
  if (cachedId) {
    return cachedId;
  }
  const id = store.state.user.sub;
  if (!id) {
    throw new Error('User Id Is Missing');
  }

  const config = {
    headers: {
      // Authorization: token,
      'X-USER': id,
    },
  };
  const response = await axios.get(`${endpoint}/me`, config);
  const data = response.data;
  if (data.result !== 'success') {
    throw new Error(data.error);
  }
  const idResult = data.data.myKiUserId;
  cacheMyUserId(idResult);
  return idResult;
};

export { getAnonymousUserId, confirmAnonymousId, getMe };
